<div class="generic-list" role="group"
  [attr.aria-label]="resolvedTranslations.labels.groupLabel">
  <ul [id]="idPrefix + '-list'" class="uba-item-list">
    <li *ngFor="let item of data; let i = index" [class]="(i % 2 === 0 ? evenClass : oddClass) || null">
      <div class="uba-item-list__header"
        role="group"
        [attr.aria-label]="t('labels.itemEntry', { index: i + 1, total: data.length })">
        <span class="uba-item-list__badge" aria-hidden="true">{{ i + 1 }} / {{ data.length }}</span>
        <span class="uba-item-list__label" aria-hidden="true">{{ resolvedTranslations.labels.itemLabel }}</span>
        <button
          *ngIf="!readonly"
          type="button"
          class="btn btn-danger btn-form-default"
          [title]="t('buttons.removeItem', { index: i + 1 })"
          [attr.aria-label]="t('buttons.removeItem', { index: i + 1 })"
          (click)="removeItem(i)">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div class="uba-item-list__body">
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="getItemContext(item, i)">
        </ng-container>
      </div>
    </li>
  </ul>
  <p *ngIf="data.length === 0 || alwaysShowPlaceholder" class="uba-item-list__empty">
    {{ data.length === 0 ? resolvedTranslations.labels.emptyList : resolvedTranslations.labels.itemLabel }}
  </p>
  <div *ngIf="!readonly" class="uba-item-list__append" [class.uba-item-list__append--no-border]="alwaysShowPlaceholder">
    <button
      type="button"
      class="btn btn-success"
      [title]="resolvedTranslations.buttons.appendItem"
      [attr.aria-label]="resolvedTranslations.buttons.appendItemLabel"
      (click)="appendItem()"
      [attr.aria-controls]="idPrefix + '-list'">
      <i class="fas fa-plus" aria-hidden="true"></i> {{ resolvedTranslations.buttons.appendItem }}
    </button>
  </div>
</div>
